import { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";
import { LOGO, BOOK_ALL } from "../data";

const LINKS = [
  { label: "Home", href: "#home" },
  { label: "Gallery", href: "#gallery" },
  { label: "Services", href: "#services" },
  { label: "Hours", href: "#hours" },
];

export const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="navbar"
      className={`fixed top-0 inset-x-0 z-50 transition-colors duration-300 ${
        scrolled ? "bg-black/90 backdrop-blur-md border-b border-white/10" : "bg-transparent"
      }`}
    >
      <nav className="max-w-6xl mx-auto px-4 sm:px-6 h-16 md:h-20 flex items-center justify-between">
        <a href="#home" data-testid="nav-logo" className="flex items-center gap-3">
          <img src={LOGO} alt="AK Cuts" className="h-10 w-10 md:h-12 md:w-12 object-contain" />
          <span className="font-display text-2xl md:text-3xl tracking-wider text-cream leading-none">
            AK CUTS
          </span>
        </a>

        <div className="hidden md:flex items-center gap-8">
          {LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-link-${l.label.toLowerCase()}`}
              className="font-mono-u text-xs tracking-widest uppercase text-cream/80 hover:text-barber-red transition-colors"
            >
              {l.label}
            </a>
          ))}
          <a href={BOOK_ALL} data-testid="nav-book-btn" className="btn-red px-6 py-2.5 text-sm">
            BOOK NOW →
          </a>
        </div>

        <button
          data-testid="nav-menu-toggle"
          onClick={() => setOpen((v) => !v)}
          className="md:hidden text-cream p-2"
          aria-label="Menu"
        >
          {open ? <X size={26} /> : <Menu size={26} />}
        </button>
      </nav>

      {open && (
        <div data-testid="mobile-menu" className="md:hidden bg-black/95 border-t border-white/10 px-6 py-6 flex flex-col gap-5">
          {LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              onClick={() => setOpen(false)}
              className="font-display text-3xl tracking-wide text-cream hover:text-barber-red transition-colors"
            >
              {l.label}
            </a>
          ))}
        </div>
      )}
    </header>
  );
};
